import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { MenuItem, Nav, Navbar, NavDropdown, Modal, Button } from 'react-bootstrap';
import PermissionHelper from '../components/permission-wrapper';
import UnlinkGoogleAccountModal from '../coordinators/unlink-google-account-modal';

@inject('appStore')
@observer
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false, displayName: '' };
    }

    openModal = () => {
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    handleSaveDisplayName(props) {
        props.appStore.coordinatorDetailStore.coordinator.displayName = this.state.displayName;
        props.appStore.coordinatorStore.updateSelectedCoordinatorFields(
            props.appStore.coordinatorDetailStore.coordinator
        );
        this.closeModal();
    }

    handleChangeDisplayName(e) {
        this.setState({ displayName: e.target.value });
    }
    handleSignOut(e) {
        this.props.appStore.authStore.signOut();
    }

    handleUnlink() {
        this.props.appStore.viewStore.showUnlinkGoogleAccountModal();
    }

    render() {
        let currentUser = this.props.appStore.coordinatorDetailStore.coordinator;
        return (
            <Navbar onSelect={this.handleOnSelect}>
                <Modal show={this.state.showModal} onHide={this.closeModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Display Name</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="justify-content-center text-center">
                        <p> Please enter your name to display for all templates and email signatures</p>
                        <br />
                        <input
                            type="text"
                            placeholder={currentUser.displayName}
                            onChange={(e) => this.handleChangeDisplayName(e)}
                            size="md"
                        ></input>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={() => this.handleSaveDisplayName(this.props)}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="#">SkyTC Admin</a>
                    </Navbar.Brand>
                </Navbar.Header>

                <Nav className="pull-right">
                    {currentUser && currentUser.hasGoogleCredentials ? (
                        <img src={currentUser.profile.photo} style={{ height: '50px' }}></img>
                    ) : (
                        <PermissionHelper permission="google.link">
                            <li role="presentation">
                                <a href={`/link/google?id=${currentUser.coordinatorId}`}>Link your GoogleAccount</a>
                            </li>
                        </PermissionHelper>
                    )}

                    <NavDropdown eventKey={3} title={currentUser.name} id="nav-user">
                        {currentUser && currentUser.hasGoogleCredentials && (
                            <MenuItem onClick={this.handleUnlink.bind(this)}>Unlink Google Account</MenuItem>
                        )}
                        {currentUser ? <MenuItem onClick={this.openModal}>Display Name</MenuItem> : null}
                        <MenuItem divider />
                        <MenuItem onClick={this.handleSignOut.bind(this)}>Logout</MenuItem>
                    </NavDropdown>
                </Nav>

                <UnlinkGoogleAccountModal />
            </Navbar>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/shared/header.js